import type { PropsWithChildren } from 'react';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';

import { Card } from '@/components/ui/card';
import { WarrantyCoverageStatus } from '@/warranty/domain/entities/warranty-status';

import { Disclosure, DisclosurePanel, DisclosureTitle } from './disclosure';

HC_more(Highcharts);

export type PlotSectionProps = PropsWithChildren<{
  sectionName: string | React.ReactNode;
  sectionStatus?: WarrantyCoverageStatus;
}>;
export function PlotSection({
  children,
  sectionStatus,
  sectionName,
}: PlotSectionProps) {
  return (
    <Disclosure className="w-full min-w-[1000px]">
      {({ open }: { open: boolean }) => (
        <>
          <DisclosureTitle status={sectionStatus}>
            <span>{sectionName}</span>
          </DisclosureTitle>

          {/* Render the content conditionally based on `open` */}
          {open && (
            <DisclosurePanel className="w-full">
              <dl className="flex h-auto flex-col items-start justify-start self-stretch p-4">
                <Card className="w-full overflow-x-auto">{children}</Card>
              </dl>
            </DisclosurePanel>
          )}
        </>
      )}
    </Disclosure>
  );
}
